<script lang="ts">
	import { onMount } from 'svelte'
	import { track } from '$lib/utils/track'
	import Button from '../buttons/Button.svelte'
	import { goto } from '$app/navigation'

	let parallaxOffset = $state(0)
	let parallaxElementCTA: HTMLElement | null = $state(null)
	let startOffset = $state(0) // Changed from $derived to $state

	// Move the offset calculation to a function that runs after mount
	const calculateStartOffset = () => {
		if (parallaxElementCTA) {
			startOffset = parallaxElementCTA.getBoundingClientRect().top + window.scrollY
		}
	}

	const updateParallax = () => {
		if (!parallaxElementCTA) return // Guard clause

		const scrolled = window.scrollY
		const distanceToScrollStart = startOffset - scrolled

		if (
			distanceToScrollStart <= window.innerHeight &&
			distanceToScrollStart >= -parallaxElementCTA.offsetHeight
		) {
			parallaxOffset = (scrolled - startOffset) * 0.2
		}
	}

	onMount(() => {
		calculateStartOffset() // Calculate initial offset
		window.addEventListener('scroll', updateParallax)
		// Recalculate on resize to handle layout changes
		window.addEventListener('resize', calculateStartOffset)

		return () => {
			window.removeEventListener('scroll', updateParallax)
			window.removeEventListener('resize', calculateStartOffset)
		}
	})

	function applyForGuide() {
		track('Apply to Guide Clicked')
		goto('/store')
		// window.open('https://abqi8g6kjwn.typeform.com/to/CY91sRBV', '_blank')
	}
</script>

<section
	bind:this={parallaxElementCTA}
	class="relative overflow-hidden bg-black py-20 sm:py-28 lg:py-36"
	data-testid="CallToAction"
>
	<div
		class="hidden lg:inline-block absolute top-0 left-0 w-full h-[700px] bg-no-repeat bg-cover bg-center"
		style="background-image: url('/visuals/stock/parallax2.webp'); background-attachment: fixed; transform: translateY({parallaxOffset}px);"
	>
		<!-- Save space -->
	</div>

	<div class="absolute left-20 top-1/2 -translate-y-1/2 sm:left-1/2 sm:-translate-x-1/2">
		<!-- <CircleBackground color="#FF006E" id="circle-bg-cta" /> -->
	</div>
	<div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative">
		<div class="mx-auto max-w-md sm:text-center">
			<h2 class="text-3xl font-bold tracking-tight text-white lg:text-4xl">
				Join a Community Where Every Journey Matters
			</h2>
			<p class="mt-4 text-lg text-brand-gray-3">
				Unite with Airheart's vibrant creator network. Together, we craft, share, and benefit.
			</p>
			<div class="mt-8 flex justify-center">
				<Button onclick={applyForGuide} class="mt-10 max-w-[240px]">Set Up Your Store</Button>
			</div>
		</div>
	</div>
</section>
